export default __webpack_public_path__ + "media/images/logo-symbol-icon-e5aaf941726b9533bba9f15afbd58963.svg";